var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { CLOSE_WEIGHT_DISPUTE_REQUEST, closeWeightDisputeFailure, closeWeightDisputeSuccess } from "../../actions";
import APIIN from "../../../utils/APIIN";
const closeWeightDiscrepancy = (action) => __awaiter(void 0, void 0, void 0, function* () {
    console.log("getWeightDiscrepancy action", action.payload);
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.post("/report/admin/weight/dispute/batch/close", action.payload)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* closeWeightDiscrepancyWorker(action) {
    try {
        const data = yield call(closeWeightDiscrepancy, action);
        yield put(closeWeightDisputeSuccess(data));
    }
    catch (error) {
        yield put(closeWeightDisputeFailure(error));
    }
}
export function* watchCloseWeightDiscrepancyData() {
    yield takeLatest(CLOSE_WEIGHT_DISPUTE_REQUEST, closeWeightDiscrepancyWorker);
}
